import { APIService } from "../../../../../../network/api/APIService";

export const AdminAffiliatePartnerData = (data) => {
    return APIService({
        endpoint: "/affiliate/admin/partners/item/",
        method: "PATCH",
        data,
    });
};
